import { Component, toNative, Vue } from '@natureos/vue-facing-decorator';

@Component
class Box extends Vue {}

export default toNative(Box);
export { default as Box } from './box.component.vue';
